export default __webpack_public_path__ + "static/0289-7726ced4e24f155d8707afd509b626ec.png";